<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="FMH1"><span class="rh CharOverride-3"><a id="page_ix"></a><a id="page_viii"></a></span><a id="page_viii"><span class="rh">CONTENTS</span></a></p><a id="page_viii">
</a><p class="CCT"><a id="page_viii"></a><a href="#/epi">Epigraph</a></p>
<p class="CCT"><a href="#/pro">Prologue</a></p>
<p class="CCT"><a href="#/ch01">The Seven</a></p>
<p class="CCT"><a href="#/ch02">Curiosity</a></p>
<p class="CCT"><span href="#/ch03" title="Link target outside of Sample">Hope</span></p>
<p class="CCT"><span href="#/ch04" title="Link target outside of Sample">Passion</span></p>
<p class="CCT"><span href="#/ch05" title="Link target outside of Sample">Courage</span></p>
<p class="CCT"><span href="#/ch06" title="Link target outside of Sample">Independence</span></p>
<p class="CCT"><span href="#/ch07" title="Link target outside of Sample">Self-Discipline</span></p>
<p class="CCT"><span href="#/ch08" title="Link target outside of Sample">Perseverance</span></p>
<p class="CBMH"><a id="page_x"></a><span href="#/note" title="Link target outside of Sample">Author’s Note</span></p>
<p class="CBMH"><span href="#/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="CBMH"><span href="#/about" title="Link target outside of Sample">About the Author</span></p>
<p class="CBMH"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?ab7e2caa